<template>
  <div id="filters-modal">
    <div
      class="modal"
      :class="modalIsActive ? 'is-active' : ''"
    >
      <div
        class="modal-background"
        @click="toggleModal"
      />
      <div class="modal-card card">
        <button
          class="delete is-rounded close-modal-x"
          @click="toggleModal"
        />
        <section
          v-if="isLoading"
          class="modal-card-body"
        >
          <loading-spinner />
        </section>
        <section
          v-else-if="!isLoading"
          class="modal-card-body"
        >
          <step-title
            class="fixed-top-on-mobile"
            title="Search Filters"
            subtitle="Enhance your search and target candidates that meet your specific needs"
            icon="fa-sliders-h"
          />
          <section class="section filter-section" style="padding-top: 0;">
            <div class="field">
              <div class="control is-expanded">
                <div class="field is-inline">
                  <input
                    id="searchFiltersModal"
                    v-model="areSearchFiltersActive"
                    type="checkbox"
                    name="searchFiltersModal"
                    class="switch is-outlined"
                  >
                  <label for="searchFiltersModal" />
                </div>
                <small class="is-size-7">Filters Enabled</small>
              </div>
            </div>
          </section>
          <!-- LOCATIONS FILTER -->
          <section
            id="locations"
            class="section filter-section"
          >
            <h5 class="title is-5">
              Locations
            </h5>
            <form @submit.prevent="addLocation()">
              <div class="field has-addons">
                <!--<label class="label">Enter Skills</label>-->
                <div class="control is-expanded">
                  <vue-google-autocomplete
                    v-if="$store.state.googleApiLoaded"
                    id="placesAutocomplete"
                    ref="VueGoogleAutocomplete"
                    placeholder="Ex: New York..."
                    :value="newLocation"
                    type="text"
                    types="(regions)"
                    class="input"
                    :existing-place="newLocation"
                    @placechanged="handleSelectLocation"
                  />
                </div>
                <button
                  class="button is-rounded is-primary control has-text-weight-bold"
                  :disabled="newLocation === ''"
                  type="submit"
                >
                  Add Filter
                </button>
              </div>
            </form>
            <div class="card card-content tags-card">
              <p
                v-if="locations.length === 0"
                class="has-text-centered has-text-grey-light"
              >
                No locations here yet...
              </p>
              <span
                v-for="(location, index) in locations"
                :key="location.key"
                class="tag is-primary is-rounded is-medium"
              >
                {{ location }}
                <button
                  class="delete is-rounded is-small"
                  @click="removeLocation(index)"
                />
              </span>
            </div>
          </section>
          <!-- INDUSTRIES FILTER -->
          <section
            id="skills"
            class="section filter-section"
          >
            <h5 class="title is-5">
              Skills
            </h5>
            <form @submit.prevent="addSkill()">
              <div class="field has-addons">
                <!--<label class="label">Enter Skills</label>-->
                <div
                  class="control is-expanded"
                  :class="isSkillsAutocCompleteLoading ? 'is-loading' : ''"
                >
                  <input
                    v-model="newSkill"
                    class="input is-fullwidth"
                    type="text"
                    placeholder="Ex: Data Science"
                    @keyup="debouncedSkillSearch($event)"
                    @keyup.up="keyboardUpSkill()"
                    @keyup.down="keyboardDownSkill()"
                  >
                  <ul
                    v-if="skillsAutoComplete.length > 0 && newSkill.length > 0"
                    class="autocomplete"
                  >
                    <li
                      v-for="(skill, index) in skillsAutoComplete"
                      :key="index"
                      :class="index === highlightedSkillIndex ? 'is-highlighted' : ''"
                      @click="addSkill()"
                      @mouseover="highlightSkill(index)"
                    >
                      {{ skill }}
                    </li>
                  </ul>
                </div>
                <button
                  class="button is-rounded is-primary control has-text-weight-bold"
                  type="submit"
                  :disabled="newSkill === ''"
                >
                  Add Filter
                </button>
              </div>
            </form>
            <div class="card card-content tags-card">
              <p
                v-if="skills.length === 0"
                class="has-text-centered has-text-grey-light"
              >
                No skills here yet...
              </p>
              <span
                v-for="(skill, index) in skills"
                :key="index"
                class="tag is-primary is-rounded is-medium"
              >
                {{ skill }}
                <button
                  class="delete is-rounded is-small"
                  @click="removeSkill(index)"
                />
              </span>
            </div>
          </section>

          <!-- INDUSTRIES FILTER -->
          <section
            id="industries"
            class="section filter-section"
          >
            <h5 class="title is-5">
              Industries
            </h5>
            <form @submit.prevent="addIndustry()">
              <div class="field has-addons">
                <!--<label class="label">Enter Skills</label>-->
                <div
                  class="control is-expanded"
                  :class="isIndustryAutoCompleteLoading ? 'is-loading' : ''"
                >
                  <input
                    v-model="newIndustry"
                    name="New Industry Filter"
                    class="input is-fullwidth"
                    type="text"
                    placeholder="Ex: Pharmaceutical"
                    @keyup="debouncedIndustrySearch($event)"
                    @keyup.up="keyboardUpIndustry()"
                    @keyup.down="keyboardDownIndustry()"
                  >
                  <ul
                    v-if="industriesAutoComplete.length > 0"
                    class="autocomplete"
                  >
                    <li
                      v-for="(result, resultsIndex) in industriesAutoComplete"
                      :key="result.key"
                      :class="resultsIndex === highlightedIndustryIndex ? 'is-highlighted' : ''"
                      @click="addIndustry()"
                      @mouseover="highlightIndustry(resultsIndex)"
                    >
                      {{ result }}
                    </li>
                  </ul>
                </div>
                <button
                  class="button is-rounded is-primary control has-text-weight-bold"
                  type="submit"
                  :disabled="newIndustry === ''"
                >
                  Add Filter
                </button>
              </div>
            </form>
            <div class="card card-content tags-card">
              <p
                v-if="industries.length === 0"
                class="has-text-centered has-text-grey-light"
              >
                No industries here yet...
              </p>
              <span
                v-for="(industry, index) in industries"
                :key="industry.key"
                class="tag is-primary is-rounded is-medium"
              >
                {{ industry }}
                <button
                  class="delete is-rounded is-small"
                  @click="removeIndustry(index)"
                />
              </span>
            </div>
          </section>

          <!-- COMPANIES FILTER -->
          <section
            class="section filter-section"
          >
            <h5 class="title is-5">
              Companies
            </h5>
            <div>
              <p class="title is-size-6">
                Annual Revenue
              </p>
              <div v-for="annualRevenue in annualRevenueOptions" :key="annualRevenue.key" class="field">
                <input
                  :id="`${annualRevenue}-checkbox`"
                  v-model="companies.annualRevenue"
                  :value="annualRevenue"
                  class="is-checkradio"
                  type="checkbox"
                  :name="`${annualRevenue}-checkbox`"
                >
                <label :for="`${annualRevenue}-checkbox`">
                  <small class="is-size-7-mobile">{{ annualRevenue }}</small>
                </label>
              </div>
            </div>
            <div>
              <p class="title is-size-6">
                Number of Employees
              </p>
              <div class="field">
                <input
                  id="exampleCheckbox"
                  v-model="companies.numberOfEmployees"
                  class="is-checkradio"
                  type="checkbox"
                  name="exampleCheckbox"
                >
                <label for="exampleCheckbox">
                  <small class="is-size-7-mobile">1 - 10</small>
                </label>
              </div>
              <div class="field">
                <input
                  id="exampleCheckbox"
                  v-model="companies.numberOfEmployees"
                  class="is-checkradio"
                  type="checkbox"
                  name="exampleCheckbox"
                >
                <label for="exampleCheckbox">
                  <small>10 - 100</small>
                </label>
              </div>
              <div class="field">
                <input
                  id="exampleCheckbox"
                  v-model="companies.numberOfEmployees"
                  class="is-checkradio"
                  type="checkbox"
                  name="exampleCheckbox"
                >
                <label for="exampleCheckbox">
                  <small>100 - 1,000</small>
                </label>
              </div>
              <div class="field">
                <input
                  id="exampleCheckbox"
                  v-model="companies.numberOfEmployees"
                  class="is-checkradio"
                  type="checkbox"
                  name="exampleCheckbox"
                >
                <label for="exampleCheckbox">
                  <small>1,000 - 10,000</small>
                </label>
              </div>
              <div class="field">
                <input
                  id="exampleCheckbox"
                  v-model="companies.numberOfEmployees"
                  class="is-checkradio"
                  type="checkbox"
                  name="exampleCheckbox"
                >
                <label for="exampleCheckbox">
                  <small>10,000+</small>
                </label>
              </div>
            </div>
            <div>
              <p class="title is-size-6">
                Corporate Structure
              </p>
              <div class="field">
                <input
                  id="exampleCheckbox"
                  v-model="companies.numberOfEmployees"
                  class="is-checkradio"
                  type="checkbox"
                  name="exampleCheckbox"
                >
                <label for="exampleCheckbox">
                  <small class="is-size-7-mobile">Private</small>
                </label>
              </div>
              <div class="field">
                <input
                  id="exampleCheckbox"
                  v-model="companies.numberOfEmployees"
                  class="is-checkradio"
                  type="checkbox"
                  name="exampleCheckbox"
                >
                <label for="exampleCheckbox">
                  <small>Public</small>
                </label>
              </div>
              <div class="field">
                <input
                  id="exampleCheckbox"
                  v-model="companies.numberOfEmployees"
                  class="is-checkradio"
                  type="checkbox"
                  name="exampleCheckbox"
                >
                <label for="exampleCheckbox">
                  <small>Non-Profit</small>
                </label>
              </div>
              <div class="field">
                <input
                  id="exampleCheckbox"
                  v-model="companies.numberOfEmployees"
                  class="is-checkradio"
                  type="checkbox"
                  name="exampleCheckbox"
                >
                <label for="exampleCheckbox">
                  <small>Startup</small>
                </label>
              </div>
              <div class="field">
                <input
                  id="exampleCheckbox"
                  v-model="companies.numberOfEmployees"
                  class="is-checkradio"
                  type="checkbox"
                  name="exampleCheckbox"
                >
                <label for="exampleCheckbox">
                  <small>Government</small>
                </label>
              </div>
            </div>
          </section>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash-es';

import StepTitle from '@/components/CandidateProfile/StepTitle';
import VueGoogleAutocomplete from '@/components/Utilities/VueGoogleAutocomplete';

export default {
  name: 'FiltersModal',
  components: {
    StepTitle,
    VueGoogleAutocomplete
  },
  props: {
    modalIsActive: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      isLoading: false,
      locations: [],
      industries: [],
      professions: [],
      skills: [],
      newLocation: '',
      newIndustry: '',
      newSkill: '',
      companies: {
        numberOfEmployees: [],
        annualRevenue: []
      },
      industriesAutoComplete: [],
      highlightedIndustryIndex: 0,
      focusedindustryIndex: 0,
      isIndustryAutoCompleteLoading: false,
      isSkillsAutocCompleteLoading: false,
      skillsAutoComplete: [],
      highlightedSkillIndex: []
    };
  },
  computed: {
    areSearchFiltersActive: {
      get () {
        return this.$store.state.areSearchFiltersActive;
      },
      set () {
        this.$store.dispatch('handleToggleSearchFilters', !this.areSearchFiltersActive);
      }
    }
  },
  created () {
    this.locations = this.$store.state.activeSearch.filters.location;
    this.industries = this.$store.state.activeSearch.filters.industries;
    this.skills = this.$store.state.activeSearch.filters.skills;
  },
  methods: {
    toggleModal () {
      this.$emit('toggleModal', false);
    },

    addLocation () {
      if (this.newLocation === '') return;

      if (!this.locations.includes(this.newLocation)) {
        this.locations.push(this.newLocation);
      }
      this.newLocation = '';
      this.$refs.VueGoogleAutocomplete.clear();
      this.$emit('updateLocations', this.locations);
    },

    removeLocation (index) {
      if (index > -1) {
        this.locations.splice(index, 1);
        this.$emit('updateLocations', this.locations);
      }
    },

    addIndustry (industry) {
      if (this.newIndustry === '') return;

      if (!this.industries.includes(this.industriesAutoComplete[this.highlightedIndustryIndex])) {
        this.industries.push(this.industriesAutoComplete[this.highlightedIndustryIndex]);
      }

      this.newIndustry = '';
      this.industriesAutoComplete = [];
      this.$emit('updateIndustries', this.industries);
    },

    removeIndustry (index) {
      if (index > -1) {
        this.industries.splice(index, 1);
        this.$emit('updateIndustries', this.industries);
      }
    },

    addSkill () {
      if (this.newSkill === '') return;

      if (!this.skills.includes(this.skillsAutoComplete[this.highlightedSkillIndex])) {
        this.skills.push(this.skillsAutoComplete[this.highlightedSkillIndex]);
      }

      this.newSkill = '';
      this.$emit('updateSkills', this.skills);
    },

    removeSkill (index) {
      if (index > -1) {
        this.skills.splice(index, 1);
        this.$emit('updateSkills', this.skills);
      }
    },

    handleSelectLocation (addressData, placeResultData, id) {
      this.newLocation = this.trimLocation(placeResultData.formatted_address);
    },

    trimLocation (locationString) {
      return locationString.substring(0, locationString.length - 5); // Remove ', USA' on the tail-end of addresses.
    },

    debouncedIndustrySearch: debounce(function ($event) {
      this.searchForIndustries($event);
    }, 200),

    debouncedSkillSearch: debounce(function ($event) {
      this.searchForSkills($event);
    }, 200),

    searchForIndustries ($event) {
      // this.checkForm();
      /* If user presses UP or DOWN keys, the search will NOT run.
            This prevents running searches when user is trying to navigate
            dropdown options. */
      if (
        $event.code === 'ArrowUp'
        || $event.code === 'ArrowDown'
        || $event.code === 'Enter'
      ) {
        return;
      }

      let query = this.newIndustry;

      if (query.length === 0) {
        this.isIndustryAutoCompleteLoading = false;
        this.industriesAutoComplete = [];
        return;
      }

      if (query.length < 2) {
        this.isIndustryAutoCompleteLoading = false;
        return;
      }

      this.industriesAutoComplete = [];
      this.industriesAutoComplete.push(query);

      this.isIndustryAutoCompleteLoading = true;
      /* We use the current query as the first result to allow the
            user to select their written option */
      this.$store.dispatch('getIndustries', query)
        .then(response => {
          // Here we concatenate the user's query with all other results.
          let industriesResults = this.industriesAutoComplete.concat(response.data.data.industries); // eslint-disable-line

          if (response.data.data.industries.includes(query)) {
            industriesResults.shift(); // Remove first entry (query) if it is a duplicate.
          }
          this.industriesAutoComplete = industriesResults;
          this.isIndustryAutoCompleteLoading = false;
        })
        .catch(error => console.log(error));
    },

    searchForSkills ($event) {
      /* If user presses UP or DOWN keys, the search will NOT run.
            This prevents running searches when user is trying to navigate
            dropdown options. */
      if ($event.code === 'ArrowUp' || $event.code === 'ArrowDown') {
        return;
      }

      if (this.newSkill.length > 1) {
        this.isSkillsAutocompleteLoading = true;
        /* We use the current query as the first result to allow the
                user to select their written option */
        this.skillsAutoComplete = [this.newSkill];
        this.$store.dispatch('getSkills', this.newSkill)
          .then(response => {
            // Here we concatenate the user's query with all other results.
            let skillsResults = this.skillsAutoComplete.concat(
              response.data.data.skill
            );
            this.skillsAutoComplete = skillsResults;
            if (response.data.data.skill.includes(this.newSkill)) {
              this.skillsAutoComplete.shift(); // Remove duplicate result if query is found in results array.
            }
            this.isSkillsAutocCompleteLoading = false;
          })
          .catch(error => console.log(error));
      }
    },

    keyboardDownIndustry () {
      this.highlightedIndustryIndex++;
    },

    keyboardUpIndustry () {
      this.highlightedIndustryIndex--;
    },

    keyboardDownSkill () {
      this.highlightedSkillIndex++;
    },

    keyboardUpSkill () {
      this.highlightedSkillIndex--;
    },

    highlightIndustry (index) {
      this.highlightedIndustryIndex = index;
    },

    highlightSkill (index) {
      this.highlightedSkillIndex = index;
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-card {
  margin: 0 0.5rem;
}

.filter-section {
  padding: 1rem 0.5rem;
  //border-bottom: 1px solid hsl(0, 0%, 86%);
}

.tags-card {
  margin-top: 2rem;
  border-radius: 4px;
  box-shadow: 0 2px 6px 0 rgba(77, 101, 117, 0.25);
  margin-bottom: 1rem;
  padding: 2rem;
  box-sizing: border-box;
}

.tag {
  margin: 0.25rem;
}

.fa-sliders-h {
  transform: rotate(90deg);
  margin-top: 1.05rem;
  margin-right: 0.5rem;
}

.modal-card {
  max-height: 90vh;
}

.close-modal-x {
  position: absolute;
  top: 0;
  right: 0;
  margin: 1rem;
  z-index: 2;
}
@media screen and (max-width: 767px) {
  .modal-card {
    min-width: 100%;
    min-height: 100%;
    border-radius: 0;
  }
  .is-first {
    margin-top: 3.75rem;
  }
  .fixed-top-on-mobile {
    position: fixed;
    top: 0;
    padding: 1rem 1rem 1rem 0;
    background: white;
    z-index: 1;
    width: 100%;
  }
}

.is-highlighted {
  background-color: $primary;
  color: white;
  transition: all 0.2s ease;
}

.fa-times-circle {
  position: absolute;
  right: -6px;
  top: -6px;
  cursor: pointer;
}

select:invalid {
  border-color: hsl(0, 0%, 86%);
}

.autocomplete {
  position: absolute;
  z-index: 10;
  background-color: white;
  width: 100%;
  max-height: 150px;
  overflow: scroll;
  border: 1px solid $primary;
  border-top: none;
  margin-top: -1px;
  transition: all 0.2s ease;
}

.is-highlighted {
  background-color: $primary;
  color: white;
  transition: all 0.2s ease;
}

li {
  padding: 0 0.5rem;
  cursor: pointer;
}
</style>
